module.exports = __webpack_public_path__ + "6ef434c948ed5f1c036b31357a8e5057.svg";